import { render, staticRenderFns } from "./GuidesSummary.vue?vue&type=template&id=5492a14c"
import script from "./GuidesSummary.vue?vue&type=script&lang=js"
export * from "./GuidesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports